module.exports = __webpack_public_path__ + "static/img/product-2.adef025.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/product-2.png
// module id = 3l1p
// module chunks = 1